import { IContentType, ICustomer, IKeyword } from '../../graphql/queries/keyword.queries'
import { CustomerActions } from 'src/actions/customer-actions'
import get from 'lodash-es/get'
import moment from 'moment'

export function allowedContentTypes(types: IContentType[], planWords = 0): IContentType[] {
  if (planWords) {
    return types.filter((type) => {
      return planWords >= type.wordMin && planWords <= type.wordMax
    })
  } else {
    return [types.find(type => type.code === 'blog-post')]
  }
}

export function hasPostLimitAndPostCredits(customer: ICustomer, keyword: IKeyword) {
  return !!keyword.postLimit && customer.postCreditsCount >= keyword.postLimit
}

export function hasPostLimit(keyword: IKeyword) {
  return !!keyword.postLimit
}

export function isNotDeclined(keyword: IKeyword): boolean {
  return !['declined', 'auto_declined'].includes(keyword.state)
}

export function updateCustomersNavRequestsCount(data: any, customerActions: CustomerActions): void {
  const keyword = get(data, 'keyword')
  const request = get(data, 'request')
  if (keyword) {
    const activeKeywordsCount = get(keyword, 'customer.activeKeywordsCount')
    const customerId = get(keyword, 'customerId') || get(keyword, 'customer.id')
    if ( (activeKeywordsCount || activeKeywordsCount === 0) && customerId) {
      customerActions.modifyCustomer(customerId, { activeKeywordsCount })
    }
  }
  if (request) {
    const activeRequestsCount = get(request, 'customer.activeRequestsCount')
    const customerId = get(request, 'customerId') || get(request, 'customer.id')
    if ( (activeRequestsCount || activeRequestsCount === 0) && customerId) {
      customerActions.modifyCustomer(customerId, { activeRequestsCount })
    }
  }
}

export function assignedWithoutDeadline(keyword: IKeyword): boolean {
  return keyword.writer && !keyword.deadline
}

export function multiplePostsFulfilled(keyword: IKeyword): boolean {
  return keyword.postLimit &&
    keyword.postLimit !== 1 &&
    keyword.postLimit <= keyword.postedCount
}

// ***************** DEADLINE UTILS **************



export function getMinDeadlineDate(deadlineBuffer: number): Date {
  const minHoursForWriters = 72 // Change this if needed
  const buffer = deadlineBuffer + minHoursForWriters
  return moment().add(buffer, 'h').toDate()
}

export function getMaxDeadlineDate(deadlineBuffer: number): Date {
  const minDeadlineDate = getMinDeadlineDate(deadlineBuffer)
  return moment(minDeadlineDate).add(2, 'months').toDate()
}

export function hasViableDeadline(keyword: IKeyword, deadlineBuffer: number): boolean {
  if (!keyword.deadline) return true
  const deadline = new Date(keyword.deadline)
  const minDeadlineDate = getMinDeadlineDate(deadlineBuffer)
  const maxDeadlineDate = getMaxDeadlineDate(deadlineBuffer)
  return (deadline >= minDeadlineDate && deadline <= maxDeadlineDate)
}

export function getViableDeadline(deadlineBuffer: number): Date {
  const minDeadlineDate = getMinDeadlineDate(deadlineBuffer)
  return moment(minDeadlineDate).add(1, 'week').toDate()
}
